import React from "react";
import { Navigate } from "react-router-dom";
import { isStripe } from "../../utils/paymentProvider";

/**
 * Route-level guard for the legacy raw-PII / AeroSync bank screens. Under Stripe,
 * these screens (which collect raw SSN/bank or post the AeroSync `user_password`
 * in the clear) must be unreachable no matter which entry point navigates to
 * them — so we redirect to the Stripe equivalent at the route boundary instead
 * of chasing every caller. Under aeropay the legacy element renders unchanged.
 *
 * `redirectTo` is the Stripe route to send the user to (add-card for the
 * payer/bank screens, onboarding for the payout screen).
 */
export const StripeRouteGuard = ({ element, redirectTo }) =>
  isStripe() ? <Navigate to={redirectTo} replace /> : element;

export default StripeRouteGuard;
